'use client';

import { createBrowserClient } from '@supabase/ssr';
import { settings } from './settings';

const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL || '';
const supabaseKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY || '';
const MICROSOFT_GRAPH_CRM_SCOPES =
  'openid email profile offline_access User.Read Files.Read.All Sites.Read.All';

export function createSupabaseBrowserClient() {
  return createBrowserClient(supabaseUrl, supabaseKey, settings);
}

function getSafeCallbackUrl(callbackUrl: string | null) {
  if (!callbackUrl) return '/';

  if (callbackUrl.startsWith('/') && !callbackUrl.startsWith('//')) {
    return callbackUrl;
  }

  try {
    const url = new URL(callbackUrl);
    if (url.origin === window.location.origin) {
      return `${url.pathname}${url.search}${url.hash}`;
    }
  } catch {
    return '/';
  }

  return '/';
}

export async function signInWithAzure() {
  const urlParams = new URLSearchParams(window.location.search);
  const callbackUrl = getSafeCallbackUrl(urlParams.get('callbackUrl'));
  const supabase = createSupabaseBrowserClient();
  const { data, error } = await supabase.auth.signInWithOAuth({
    provider: 'azure',
    options: {
      redirectTo: `${window.location.origin}/auth/callback?next=${encodeURIComponent(
        callbackUrl,
      )}`,
      scopes: MICROSOFT_GRAPH_CRM_SCOPES,
      queryParams: {
        prompt: 'login',
      },
    },
  });
  if (error) console.error('Error signing in with Azure:', error);
  return { data, error };
}
